import {useGetEditableSubscriptionContext} from "../../../../subscriptions-feature/useCases/edit-subscription/context/get-editable-subscription";
import {SubscriptionCustomerInsights} from "./customers-section";
import {SubscriptionSalesAndInsightsRevenueSection} from "./revenue-section";

export function SubscriptionSalesAndInsights() {
  const {
    state: {
      subscriptionData: {productSubscription},
    },
  } = useGetEditableSubscriptionContext();
  const {id, name} = productSubscription;

  return (
    <div>
      <SubscriptionSalesAndInsightsRevenueSection
        subscriptionId={id}
        defaultCurrency={productSubscription.defaultCurrency}
        fallbackTotalRevenue={productSubscription.totalRevenue}
      />
      <SubscriptionCustomerInsights subscriptionId={id} subscriptionTitle={name} />
    </div>
  );
}
